export default __webpack_public_path__ + "static/disconnected-ce6123073d6dca23459438b3984d560b.svg";